import { Content } from "@/services/content/types";
import { ARTICLE_TYPES } from "@/services/content/utils";
import * as ArticleTeaser from "./article";
import * as ChronicleTeaser from "./chronicle";
import * as InterviewTeaser from "./interview";
import * as PlayTeaser from "./play";
import * as PodcastTeaser from "./podcast";

type SmallProps = {
  item: Content.Entry;
};

const Small = (props: SmallProps) => {
  if (
    props.item.sys.contentType.sys.id === "play" ||
    props.item.sys.contentType.sys.id === "play-episode"
  ) {
    return <PlayTeaser.small play={props.item} />;
  }

  if (props.item.sys.contentType.sys.id === "podcast-episode") {
    return <PodcastTeaser.small podcast={props.item} />;
  }

  if (
    props.item.sys.contentType.sys.id === "article" ||
    props.item.sys.contentType.sys.id === "externalContent"
  ) {
    const type = (props.item as Content.Article).fields.type;

    if (type === ARTICLE_TYPES.CHRONICLE) {
      return <ChronicleTeaser.small article={props.item} />;
    }

    if (type === ARTICLE_TYPES.INTERVIEW || type === ARTICLE_TYPES.REPORTAGE) {
      return <InterviewTeaser.small article={props.item} />;
    }

    if (type === ARTICLE_TYPES.ANALYSIS || type === ARTICLE_TYPES.COMMENT) {
      return <ArticleTeaser.small article={props.item} />;
    }

    return <ArticleTeaser.small article={props.item} />;
  }

  return null;
};

export default Small;
